import { render, staticRenderFns } from "./ProtectorUpsellModal.vue?vue&type=template&id=da2ed84a"
import script from "./ProtectorUpsellModal.vue?vue&type=script&lang=js"
export * from "./ProtectorUpsellModal.vue?vue&type=script&lang=js"
import style0 from "./ProtectorUpsellModal.vue?vue&type=style&index=0&id=da2ed84a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports